<template>
  <div class="activity-scheduling">
    <div class="activity-title">第112届全国糖酒会论坛活动排期表</div>

    <div class="activity-content">
      <div class="activity-item" v-for="(item, index) in activityList" :key="index">
        <div class="title-section">
          <div class="left">
            <div class="line"></div>
            <div class="title">{{item.name}}</div>
          </div>
          <div class="right">{{item.date}}</div>
        </div>
        <div class="content-section" v-for="(activity, aIndex) in item.children" :key="aIndex">
          <div class="time-area" v-if="activity.time">
            <div class="time">{{activity.time}}</div>
          </div>
          <div class="title-label">会议名称</div>
          <div class="title-content">
            <div class="title-main-content" v-if="activity.mainTitle">{{activity.mainTitle}}</div>
            <div>{{activity.title}}</div>
          </div>
          <div class="title-label">地点</div>
          <div class="title-content" style="padding-bottom: 0;">{{activity.content}}</div>
          <template v-if="activity.profile">
            <div class="title-label" style="padding-top: 12px;">简介</div>
            <div class="title-content" style="padding-bottom: 0;">{{activity.profile}}</div>
          </template>
        </div>
      </div>
    </div>
		<!-- <div class="acivity_logo">
    	<img width="25%" src="https://ef-small.oss-cn-beijing.aliyuncs.com/tangjiu/GPC.jfif">
    	<img width="25%" src="https://ef-small.oss-cn-beijing.aliyuncs.com/tangjiu/ks.png">
    	<img width="25%" src="https://ef-small.oss-cn-beijing.aliyuncs.com/tangjiu/kuaishou.jfif">
    	<img width="25%" src="https://ef-small.oss-cn-beijing.aliyuncs.com/tangjiu/wb.png">
    	<img width="25%" src="https://ef-small.oss-cn-beijing.aliyuncs.com/tangjiu/kyz.jfif">
    	<img width="25%" src="https://ef-small.oss-cn-beijing.aliyuncs.com/tangjiu/xhs.jfif">
    	<img width="25%" src="https://ef-small.oss-cn-beijing.aliyuncs.com/tangjiu/bili.png">
    </div> -->
    <div class="activity-apply">
      <div class="btn" @click="onApply">我要报名</div>
    </div>
  </div>
</template>
 
<script>
  export default {
    data() {
      return {
        activityList: [
          {
            name: '重点活动',
            date: '2025年3月20日-27日',
            children: [
              {
                time: '09:30-10:00',
                title: '2025春糖生活季（啤酒生活季、潮饮生活季、“家年华”、环球美食季、特调大师赛）',
                content: '交子大道、桂溪公园',
                profile: ''
              }
            ]
          },
          {
            name: '重点活动',
            date: '2025年3月24日',
            children: [
              {
                time: '15:00-16:30',
                title: '第112届全国糖酒商品交易会开幕欢迎会',
                content: '成都广播电视台一号演播厅',
                profile: ''
              }
            ]
          },
          {
            name: '重点活动',
            date: '2025年3月25日',
            children: [
              {
                time: '10:00-16:00',
                title: 'CFDF食饮产业发展大会',
                content: '西博城9号馆宴会厅A厅',
                profile: ''
              },
              {
                time: '16:00-17:30',
                title: 'IDEAS创新产品大赛颁奖仪式',
                content: '西博城9号馆宴会厅A厅',
                profile: ''
              },
              {
                time: '13:30-16:30',
                title: '"桃花盛开的地方-百县千品万家福”专场推介会',
                content: '西博城13号馆馆内活动区-A区',
                profile: ''
              },
              {
                time: '13:30-16:30',
                title: '绿色农业专区供采对接会',
                content: '西博城13号馆馆内活动区-B区',
                profile: ''
              }
            ]
          },
          {
            name: '重点活动',
            date: '2025年3月26日',
            children: [
              {
                time: '09:00-17:00',
                title: '绿色农业专区供采对接会',
                content: '西博城13号馆馆内活动区-B区',
                profile: ''
              },
              {
                time: '10:00-11:00',
                title: '第113届全国糖酒会推介会',
                content: '西博城9号馆重庆厅',
                profile: ''
              }
            ]
          },
          {
            name: '酒知己-酒类行业会议',
            date: '2025年3月24日',
            children: [
              {
                time: '14:00-17:00',
                mainTitle: '第一大厅 · 第一时间 · 第一发布',
                title: '2025全国糖酒会酒企战略暨酒类新品发布会',
                content: '世纪城天堂洲际酒店五层宴会厅',
                profile: ''
              }
            ]
          },
          {
            name: '酒知己-酒类行业会议',
            date: '2025年3月25日',
            children: [
              {
                time: '09:30-11:30',
                mainTitle: '发展新格局 · 酱香新突破',
                title: '2025全国糖酒会酱酒大会',
                content: '世纪城6号馆酒类活动区A厅',
                profile: ''
              },
              {
                time: '14:30-16:30',
                mainTitle: '携手70商 · 协力争上游',
                title: '金沙酒业·第112届全国糖酒会酒业大会',
                content: '世纪城6号馆酒类活动区A厅',
                profile: ''
              },
              {
                time: '09:30-11:30',
                mainTitle: '大 清 香 时 代',
                title: '2025全国糖酒会清香大会',
                content: '世纪城6号馆酒类活动区B厅',
                profile: ''
              },
              {
                time: '14:30-16:30',
                mainTitle: '信息化 · 数字化 · 智能化',
                title: '浪潮数字商业·2025全国糖酒会酒业产业互联网大会',
                content: '世纪城6号馆酒类活动区B厅',
                profile: ''
              }
            ]
          },
          {
            name: '酒知己-酒类行业会议',
            date: '2025年3月26日',
            children: [
              {
                time: '09:30-11:30',
                mainTitle: '品牌力量 · 创新未来',
                title: '第112届全国糖酒会酒业品牌官大会',
                content: '世纪城6号馆酒类活动区A厅',
                profile: ''
              },
              {
                time: '09:30-11:30',
                mainTitle: '标准引领产业 · 认证夯实品牌',
                title: '2025全国糖酒会白酒标准与认证价值大会',
                content: '世纪城6号馆酒类活动区B厅',
                profile: ''
              },
              {
                time: '14:30-16:30',
                title: '第112届全国糖酒会价值白酒大赛',
                content: '世纪城7号馆酒类活动区A厅',
                profile: ''
              },
              {
                time: '14:00-15:30',
                title: '日本酒大师班',
                content: '西博城9号馆成都厅',
                profile: ''
              },
            ]
          },
          {
            name: '食天下-大食品品类行业会议',
            date: '2025年3月25日',
            children: [
              {
                time: '09:30-12:00',
                title: '第五届中国川调产业发展大会',
                content: '西博城9号馆成都厅+重庆厅',
                profile: ''
              },
              {
                time: '13:30-17:00',
                title: '第13届调味品行业创新发展大会暨“年度创新产品”发布',
                content: '西博城9号馆成都厅+重庆厅',
                profile: ''
              },
              {
                time: '09:00-1700',
                mainTitle: '2025年第二十一届“金产品·新渠道”',
                title: '——高品质食品暨运动友好食品发展大会',
                content: '西博城10号馆会议区',
                profile: ''
              }
            ]
          },
          {
            name: '食天下-大食品品类行业会议',
            date: '2025年3月26日',
            children: [
            {
                time: '',
                title: '第112届全国糖酒商品交易会进口食品专区一对一商务对接会',
                content: '西博城10号馆会议区',
                profile: ''
              },
              {
                time: '9:30-12:00',
                title: '健康食品与科技服务大会暨健康食品专区采销对接会',
                content: '西博城9号馆南京厅+福州厅',
                profile: ''
              },
              {
                time: '13:30-17:00',
                title: '健康食品与科技服务大会暨健康食品专区采销对接会',
                content: '西博城9号馆南京厅+福州厅',
                profile: ''
              },
              {
                time: '13:30-15:00',
                title: '“绿色农业·科技创新”智慧农业发展研讨会',
                content: '西博城13号馆馆内活动区-A区',
                profile: ''
              }
            ]
          },
          {
            name: '创造赢-营销渠道行业会议',
            date: '2025年3月25日',
            children: [
            	{
                time: '10:00-12:00',
                title: '全国糖酒会VIP采购商俱乐部闭门对接会',
                content: '西博城9号馆长春厅',
                profile: ''
              },
              {
                time: '15:00-16:30',
                title: 'CFDF全域采购商选品会',
                content: '西博城9号馆宴会厅B厅',
                profile: ''
              },
              {
                time: '10:00-12:30',
                mainTitle: '酒商转型新机遇',
                title: '——美团酒饮闪电仓大会',
                content: '西博城9号馆郑州厅+广州厅+杭州厅',
                profile: ''
              },
              {
                time: '09:00-17:00',
                title: '全国糖酒会线上出口资源对接会',
                content: '西博城9号馆武汉厅',
                profile: ''
              }
            ]
          },
          {
            name: '创造赢-营销渠道行业会议',
            date: '2025年3月26日',
            children: [
              {
                time: '09:00-17:00',
                title: '全国糖酒会线上出口资源对接会',
                content: '西博城9号馆武汉厅',
                profile: ''
              }
            ]
          },
        ]
      }
    },
    methods: {
      onApply() {
        window.location.href = 'https://my.31huiyi.com/event/zh/pc/2cab0000-e954-2e4d-ce7e-08dd560882dd/auth/login?attendeeTypeId=2cab0000-e954-2e4d-0789-08dd5608e999&returnName=applyIndex'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .activity-scheduling {
    padding: 12px 15px 106px;
  }
  .activity-title {
    font-weight: 500;
    font-size: 20px;
    color: #FFFFFF;
    background: linear-gradient(#FF1EA0 0%, #FFD100 100%);
    border-radius: 5px;
    padding: 12px 0;
    text-align: center;
  }
  .activity-content {
    width: 100%;
  }
  .acivity_logo{
  	text-align: center;
  }
  .acivity_logo img{
  	margin: 10px;
  }
  .activity-apply {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 24px 15px;
    background: rgba(255, 255, 255, .95);
    box-sizing: border-box;
    .btn {
      font-weight: 400;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 24px;
      padding: 10px 0;
      background: linear-gradient(0deg, #FFD100 0%, #FF1EA0 100%);
      border-radius: 5px;
      text-align: center;
    }
  }
  .activity-item {
    
  }
  .title-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    margin-top: 5px;
    .left {
      display: flex;
      align-items: center;
      .line {
        width: 3px;
        height: 16px;
        background: #F96464;
        margin-right: 3px;
      }
      .title {
        font-weight: 500;
        font-size: 15px;
        color: rgba(0,0,0,0.65);
      }
    }
    .right {
      font-weight: 500;
      font-size: 14px;
      color: #424242;
    }
  }
  .content-section {
    padding: 12px;
    background: #ffffff;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
    .time-area {
      display: flex;
      flex-direction: row-reverse;
      .time {
        font-weight: 500;
        font-size: 13px;
        color: #FFFFFF;
        line-height: 18px;
        padding: 3px 13px;
        background: linear-gradient(-90deg, #FFD100 0%, #FF1EA0 100%);
        border-radius: 15px;
      }
    }
    .title-label {
      font-weight: 500;
      font-size: 13px;
      color: #969696;
      line-height: 18px;
    }
    .title-content {
      font-weight: 500;
      font-size: 14px;
      color: #424242;
      line-height: 20px;
      padding-top: 8px;
      padding-bottom: 12px;
    }
  }
</style>